import { useT } from "@/contexts/I18nContext";
import { useI18n } from "@/contexts/I18nContext";
import { requireEnv } from "@/lib/requireEnv";
import { SITE_EDITION } from "@/i18n";

/**
 * Sub-processors and the DPIA.
 *
 * Read-only, and it links out rather than restating. The published list is what
 * a data protection officer will cite, and a paraphrase of it inside the back
 * office would be a second version of a document that must have exactly one.
 */
export function SubProcessorsPanel() {
  const t = useT();
  const { locale } = useI18n();
  const edition = SITE_EDITION[locale];
  const site = `${requireEnv("VITE_WEB_BASE_URL").replace(/\/$/, "")}/${edition.prefix}`;

  return (
    <div className="flex flex-col gap-6">
      <section className="card p-5">
        <h2 className="section-title">{t("legal.subprocessors.title")}</h2>
        <p className="mt-2 text-sm text-ink-soft">{t("legal.subprocessors.body")}</p>
        <a
          href={`${site}/legal/${edition.subprocessors}/`}
          target="_blank"
          rel="noreferrer"
          className="mt-3 inline-block text-sm text-brand underline underline-offset-2 hover:text-brand-hover"
        >
          {t("legal.subprocessors.view")}
        </a>
      </section>

      <section className="card p-5">
        <h2 className="section-title">{t("legal.dpia.title")}</h2>
        <p className="mt-2 text-sm text-ink-soft">{t("legal.dpia.body")}</p>
        <a
          href={`${site}/contact/`}
          target="_blank"
          rel="noreferrer"
          className="mt-3 inline-block text-sm text-brand underline underline-offset-2 hover:text-brand-hover"
        >
          {t("legal.dpia.request")}
        </a>
      </section>
    </div>
  );
}
